const _defaultExport = new String(".button-content{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;color:white;.play-icon{padding-right:8px;svg{width:18px;height:18px}}.play-text{font-size:1rem}}");
_defaultExport.__hash = "595d037c7d9fec5c";
export default _defaultExport;
